import type firebase from 'firebase/compat/app'
import { ReactNode, useEffect, useState } from 'react'

import { SandboxChatUser, signInSandboxChatUser } from './utils/sandboxChatAuth'

interface Props {
  auth: firebase.auth.Auth
  user: SandboxChatUser
  children: ReactNode
}

export const SandboxChatAuth = ({ auth, user, children }: Props) => {
  const [status, setStatus] = useState<'PREPARING' | 'READY' | 'FAILURE'>('PREPARING')
  const { sub, email, emailVerified, name, picture } = user

  useEffect(() => {
    let active = true
    signInSandboxChatUser(auth, { sub, email, emailVerified, name, picture }).then(
      () => {
        if (active) {
          setStatus('READY')
        }
      },
      () => {
        if (active) {
          setStatus('FAILURE')
        }
      }
    )
    // Firebase sign-in cannot be cancelled. Cleanup prevents an abandoned
    // iframe's result from opening its application; it does not sign anyone out.
    return () => {
      active = false
    }
  }, [auth, sub, email, emailVerified, name, picture])

  if (status === 'READY') {
    return <>{children}</>
  }
  return (
    <p role={status === 'FAILURE' ? 'alert' : 'status'}>
      {status === 'FAILURE'
        ? 'Chat sign-in failed. Leave Chat and reopen it to retry.'
        : 'Signing in to Chat…'}
    </p>
  )
}
